import { Component, OnInit } from '@angular/core';
import { ContextService } from '../context.service';

@Component({
    selector: 'mutara-selected',
    template: `@if(!!data){<mat-card-title >Reviewing: {{ data?.label }}</mat-card-title>}`,
    standalone: false
})
export class DisplaySelectionComponent implements OnInit {
  data: any;

  constructor(private context: ContextService) { }

  ngOnInit(): void {
    this.context.subscribeTo("selectedData", data =>  this.data = data);
  }

}
